import React from "react";
import { motion } from "framer-motion";
import Footer from "../Base/Footer";
import Navbar from "./components/Navbar";

const user = {
  name: "Lauren Olivier",
  accountType: "EXECUTIVE",
  avatarUrl: "https://i.ibb.co/xqnrW3cK/woman-pfp.jpg",
  hasNotifications: true,
};

const portalPageStaggerVariants = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      duration: 0.28,
      ease: [0.22, 1, 0.36, 1],
      staggerChildren: 0.08,
      delayChildren: 0.03,
    },
  },
};

const portalFadeUpVariants = {
  hidden: { opacity: 0, y: 16 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.34, ease: [0.22, 1, 0.36, 1] },
  },
};

export default function NavPagePlaceholder({ title, currentPage }) {
  return (
    <div className="ed-wrapper">
      <motion.div
        className="ed-main"
        initial="hidden"
        animate="show"
        variants={portalPageStaggerVariants}
      >
        <Navbar user={user} currentPage={currentPage} />

        <motion.section className="hero-board bg-2" variants={portalFadeUpVariants}>
          <div className="hero-board__overlay" />
          <div className="hero-board__content">
            <h1 className="hero-board__title">{title}</h1>
          </div>
        </motion.section>

        <motion.section
          className="portal-page__header"
          variants={portalFadeUpVariants}
          style={{
            minHeight: "600px",
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "center",
            paddingTop: "80px",
          }}
        >
          <h2 className="portal-page__heading portal-page__heading--coming-soon">Coming soon</h2>
        </motion.section>

        <div className="ed-footer">
          <Footer alternate={true} />
        </div>
      </motion.div>
    </div>
  );
}
